let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a6jC4")).then(() => parcelRequire('7GItp'));